module.exports = __webpack_public_path__ + "img/triangle-down.2eb08cf3.svg";